module.exports = __webpack_public_path__ + "static/media/es.36938bbe.svg";